import Core from '../Core/Core';
import { Actions } from '../State/Actions/Actions';
import { IGameState, IStateSubcriber } from '../State/Store/store';
// import getLogger, { ILogger } from '../Core/Logger';
import { IStateMissions } from '../State/reducers/missions';
import { MISSION_REFRESH_TIME } from '../Config/Missions';
import DateUtils from '../Utils/DateUtils';

// const logger: ILogger = getLogger('[MISSIONS_MANAGER]:');

export default class Missions {
    private timerListener: IStateSubcriber<any>;
    private listeners: Array<IStateSubcriber<any>>;

    private missionsTimer: number;

    constructor() {
        // listeners for added, completed, update
        // send updates needed to hud view??

        this.timerListener = {
            callback: (state: IStateMissions, pre: IStateMissions) => {
                if (state.refreshTimer !== pre.refreshTimer) {
                    this.missionsTimer = state.refreshTimer;
                }
            },
            selector: (state: IGameState) => state.StateMissions,
            id: 'missionTimer',
        };

        this.listeners = [this.timerListener];
        Core.store.addListener(this.listeners);

        this.missionsTimer = Core.store.getState().StateMissions.refreshTimer;
    }

    public cleanUp() {
        Core.store.removeListener(this.listeners);
    }

    public update() {
        if (this.missionsTimer) {
            if (DateUtils.timeRemainingTo(MISSION_REFRESH_TIME + this.missionsTimer) <= 0) {
                Core.store.dispatch(Actions.missionRefreshComplete());
            }
        }
    }
}
